const createEditorAction = (action) => {
  return `WECHAT_MOMENT_EDITOR@${action}`;
};

export const MomentEditorAction = {
  initDefaultState: createEditorAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: createEditorAction('SET_LOADING_STATUS'),
  setInitStatus: createEditorAction('SET_INIT_STATUS'),
  setRoomTypeList: createEditorAction('SET_ROOM_TYPE_LIST'),
  setRoomMarketingOption: createEditorAction('SET_ROOM_MARKETING_OPTION'),
  updateImageList: createEditorAction('UPDATE_IMAGE_LIST'),
  setTextType: createEditorAction('SET_TEXT_TYPE'),
  setHeaderTextStatus: createEditorAction('SET_HEADER_TEXT_STATUS'),
  setHeaderTextContent: createEditorAction('SET_HEADER_TEXT_CONTENT'),
  updateMarketingList: createEditorAction('UPDATE_MARKETING_LIST'),
  setFooterTextStatus: createEditorAction('SET_FOOTER_TEXT_STATUS'),
  setFooterTextContent: createEditorAction('SET_FOOTER_TEXT_CONTENT'),
  setCustomTextContent: createEditorAction('SET_CUSTOM_TEXT_CONTENT'),
  setPublishTriggerType: createEditorAction('SET_PUBLISH_TRIGGER_TYPE'),
  updateTriggerPresetTime: createEditorAction('UPDATE_TRIGGER_TIME_LIST'),
  setTriggerLeftId: createEditorAction('SET_TRIGGER_LEFT_ID'),
  setTriggerLeftValue: createEditorAction('SET_TRIGGER_LEFT_VALUE'),
  setTriggerDiscountId: createEditorAction('SET_TRIGGER_DISCOUNT_ID'),
  setTriggerDiscountValue: createEditorAction('SET_TRIGGER_DISCOUNT_VALUE'),
  setPublishDelayStatus: createEditorAction('SET_PUBLISH_DELAY_STATUS'),
  setPublishDelayTime: createEditorAction('SET_PUBLISH_DELAY_TIME'),
};
